/* eslint-disable react/jsx-no-target-blank */
import React, { useState, useEffect } from 'react';
import { SafeLink } from '../ui/SafeLink';



interface Testimonial {
    image: string;
    text: string;
    author: string;
    title: string;
    position: string;
    id?: string;
    url?: string;
}

interface TestimonialsProps {
    testimonials?: Testimonial[];
    title?: React.ReactNode;
}

const defaultSlides: Testimonial[] = [
    {
        //image: 'https://hncnzwww.blob.core.windows.net/www/img/testimonials/harvey-norman-commercial-aucland-coop-taxis-testimonial.jpg',
        image: 'https://hncnzwww.blob.core.windows.net/www/img/testimonials/harvey-norman-commercial-the-avenue-apartments-remuera-project.webp',
        text: 'Love the furniture, it really sets the apartment off beautifully.',
        author: '',
        title: 'The Avenue Apartments, Remuera Gardens',
        position: 'Apartment Resident',
        id: 'c2bdc8cb-0487-f111-ab0e-7c1e52636966',
        url: 'stage-to-own-the-avenue-apartments'
    },

    {
        image: 'https://hncnzwww.blob.core.windows.net/www/img/testimonials/harvey-norman-commercial-ecatch-testimonial.jpg',
        text: 'Our whole ethos as a software development company is to make recording and submitting the catch data as stress-free as possible and we could see immediately that being able to offer our clients access to support from Harvey Norman Commercial would make their lives easier.',
        author: 'David Newstead',
        title: 'eCatch',
        position: 'Co-founder',
        id: '7a1b3e6c-5872-eb11-a812-000d3acba96b',
        url: ''
    },
    {
        image: 'https://hncnzwww.blob.core.windows.net/www/img/testimonials/harvey-norman-commercial-stonewood-homes-testimonial-thumbnail.jpg',
        text: 'Our clients recognise the Harvey Norman brand, and Bosch, and we trade on their brands as much as our own.',
        author: 'Warwick Isaacs',
        title: 'Stonewood Homes Christchurch',
        position: 'Director',
        id: 'dd6af5e9-987b-eb11-a812-000d3a6ae22a',
        url: 'brand-power-benefits-christchurch-building-company'
    },
    {
        image: 'https://hncnzwww.blob.core.windows.net/www/img/testimonials/harvey-norman-commercial-aramus-testimonial-thumbnail.jpg',
        text: "It’s the people, the consistency of supply, the cost-effective and high quality product range, and the after service care. They get the job done.",
        author: 'Braden Cameron',
        title: 'Aramus',
        position: 'Director',
        id: '311d2f9f-5872-eb11-a812-000d3acba96b',
        url: 'making-life-easy-for-two-decades'
    },
];

const Testimonials: React.FC<TestimonialsProps> = ({ testimonials: slides, title, }) => {
    // console.log('[CTATestimonials] Rendered with slides:', slides);
    const [currentSlide, setCurrentSlide] = useState(0);
    const allSlides = slides && slides.length > 0 ? slides : defaultSlides;


    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % allSlides.length);
        }, 5000);
        return () => clearInterval(intervalId);
    }, [allSlides.length]);



    const handleDotClick = (index: number) => {
        setCurrentSlide(index);
    };


    return (
        <div className="bg-white w-full pt-12 pb-20 ">

            <div className="text-center text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 max-w-xl mx-auto leading-tight mb-12 pt-4 pb-4">
                {/* <span className="hero-text-gradient-red">What our clients</span> have to say */}
                {title ? (
                    title
                ) : (
                    <>
                        <span className="hero-text-gradient-red">What our clients</span> have to say
                    </>
                )}
            </div>

            <div className="mx-auto px-4 md:px-8 xl:px-0 xl:max-w-[72%]">
                <div className="relative rounded block md:flex items-stretch bg-black overflow-hidden" style={{ minHeight: '19rem' }}>
                    <div className="relative w-full md:w-1/2 h-[306px] md:h-auto md:min-h-[19rem] overflow-hidden">
                        {allSlides.map((slide, index) => (
                            <div
                                key={index}
                                className={`${index === currentSlide ? 'absolute inset-0' : 'hidden'}`}
                            >
                                <img
                                    loading="eager"
                                    src={slide.image}
                                    alt={slide.title}
                                    className="w-full h-full object-cover"
                                />
                            </div>
                        ))}
                    </div>

                    <div className="relative w-full md:w-1/2 flex items-center justify-center bg-black px-6 md:px-8 lg:px-12 py-8">
                        <svg
                            className="hidden md:block absolute inset-y-0 left-0 h-full w-24 fill-current text-black -ml-12 z-0"
                            viewBox="0 0 100 100"
                            fill="currentColor"
                            preserveAspectRatio="none slice"
                        >
                            <path d="M50 0H100L50 100H0L50 0Z" style={{ fill: 'black' }} />
                        </svg>

                        {allSlides.map((slide, index) => (
                            <div
                                key={index}
                                className={`${index === currentSlide ? 'relative z-10 w-full max-w-xl text-white text-center' : 'hidden'}`}
                            >
                                <h1 className="xl:text-2xl text-lg font-semibold">{slide.title}</h1>
                                <p className="text-lg font-semibold text-harvey-red">{slide.author}</p>
                                <p className="text-gray-400 mb-2 lg:mb-4">{slide.position}</p>
                                <p className="text-white font-extralight md:pr-6 lg:pr-4 xl:pr-0 line-clamp-4 mb-4">
                                    "{slide.text}"
                                </p>
                                {slide.url && slide.url.trim() !== '' && (
                                    <SafeLink
                                        to={`/case-studies/${slide.url}`}
                                        className="underline text-harvey-red underline-offset-4 py-2 inline-block"
                                    >
                                        Read more
                                    </SafeLink>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                <div className="flex items-center justify-center mt-8">
                    {allSlides.map((_, index) => (
                        <span
                            key={index}
                            className={`dot w-3 h-3 bg-gray-700/70 rounded-full mx-1 cursor-pointer ${index === currentSlide ? 'bg-red-700' : ''}`}
                            onClick={() => handleDotClick(index)}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Testimonials;